// extracted by css-extract-rspack-plugin
export default {"cls1":"StatelessWorkCardsUpsellModal-styles-cls1_dUV","cls2":"StatelessWorkCardsUpsellModal-styles-cls2_D-D StatelessWorkCardsUpsellModal-styles-cls1_dUV"};